import React from 'react';
import { Card } from './ui/card';
import { ExternalLink } from 'lucide-react';

export const Portfolio = ({ translations, isDark }) => {
  return (
    <section id="portfolio" className={`min-h-screen py-24 transition-colors duration-300 ${
      isDark ? 'bg-zinc-950' : 'bg-white'
    }`}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="space-y-16">
          <div className="space-y-4">
            <div className={`inline-block border-2 px-4 py-2 ${
              isDark ? 'border-cyan-400' : 'border-cyan-500'
            }`}>
              <span className={`text-sm uppercase tracking-widest font-mono ${
                isDark ? 'text-cyan-400' : 'text-cyan-600'
              }`}>Projects</span>
            </div>
            <h2 className={`text-6xl md:text-7xl font-black leading-none tracking-tighter ${
              isDark ? 'text-white' : 'text-zinc-900'
            }`}>
              {translations.portfolio.title}
            </h2>
            <div className={`h-1 w-24 ${isDark ? 'bg-cyan-400' : 'bg-cyan-500'}`}></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {translations.portfolio.items.map((project, index) => (
              <Card
                key={project.id}
                className={`border-2 overflow-hidden transition-all duration-300 group cursor-pointer ${
                  isDark 
                    ? 'bg-zinc-900 border-zinc-800 hover:border-cyan-400'
                    : 'bg-zinc-50 border-zinc-200 hover:border-cyan-500'
                }`}
              >
                <div className={`aspect-video relative overflow-hidden ${
                  isDark ? 'bg-zinc-800' : 'bg-zinc-200'
                }`}>
                  <div className={`absolute inset-0 bg-gradient-to-br opacity-0 group-hover:opacity-100 transition-opacity duration-300 ${
                    isDark ? 'from-cyan-400/20' : 'from-cyan-500/20'
                  } to-transparent`}></div>
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className={`transition-colors duration-300 ${
                      isDark 
                        ? 'text-zinc-700 group-hover:text-cyan-400'
                        : 'text-zinc-400 group-hover:text-cyan-600'
                    }`}>
                      <ExternalLink className="w-12 h-12" />
                    </div>
                  </div>
                  <div className={`absolute top-4 right-4 px-3 py-1 font-mono text-xs font-bold ${
                    isDark ? 'bg-cyan-400 text-black' : 'bg-cyan-500 text-white'
                  }`}>
                    [{String(index + 1).padStart(2, '0')}]
                  </div>
                </div>
                
                <div className="p-6 space-y-3">
                  <div className={`text-xs uppercase tracking-wider font-mono ${
                    isDark ? 'text-cyan-400' : 'text-cyan-600'
                  }`}>
                    {project.category}
                  </div>
                  <h3 className={`text-xl font-bold uppercase tracking-tight ${
                    isDark ? 'text-white' : 'text-zinc-900'
                  }`}>
                    {project.title}
                  </h3>
                  <p className={`text-sm leading-relaxed ${
                    isDark ? 'text-zinc-400' : 'text-zinc-600'
                  }`}>
                    {project.description}
                  </p>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};